// extracted by mini-css-extract-plugin
module.exports = {"container":"MarkStub__container___3f61a","image":"MarkStub__image___H6ir5","title":"MarkStub__title___mZv_7","text":"MarkStub__text___3zJJW","button":"MarkStub__button___7SAy5"};